import { TIMELINE, NEWS } from '@/mocks/gossip';

export default function Track() {
  return (
    <section id="track" className="border-b border-background-200/70 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="mb-6 flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <h2 className="flex items-center gap-2 text-2xl font-bold tracking-wide text-foreground-950 md:text-[1.7rem]">
              <i className="ri-time-line text-accent-600" aria-hidden="true" />
              事件追踪 · 谁在持续发酵
            </h2>
            <p className="mt-1.5 text-sm text-foreground-600">
              同一个瓜不追丢，从首曝到回应的每一步都补录进时间线，随时回看。
            </p>
          </div>
          <span className="inline-flex shrink-0 items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1.5 text-xs font-medium text-accent-900">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-500 opacity-75" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-600" />
            </span>
            追踪进行中
          </span>
        </div>

        <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
          {/* 左侧大时间线 */}
          <div className="lg:col-span-2">
            <ol className="relative space-y-0 border-l-2 border-primary-200 pl-5">
              {TIMELINE.map((day) => (
                <li key={day.date} className="relative pb-6 last:pb-0">
                  <span className="absolute -left-[27px] top-1 flex h-4 w-4 items-center justify-center rounded-full border-4 border-accent-500 bg-background-50" />
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="whitespace-nowrap rounded-md bg-primary-100 px-2 py-0.5 text-xs font-bold text-primary-800">
                      {day.date}
                    </span>
                    {day.items.map((it, i) => (
                      <span key={i} className="whitespace-nowrap rounded-full bg-secondary-100 px-2.5 py-1 text-[11px] text-secondary-800">
                        {it}
                      </span>
                    ))}
                  </div>
                </li>
              ))}
            </ol>
            <div className="mt-5 flex flex-wrap items-center justify-between gap-3 rounded-lg border border-accent-200 bg-accent-50/70 p-4">
              <p className="flex items-center gap-2 text-xs text-accent-900">
                <i className="ri-alarm-warning-line" aria-hidden="true" />
                置顶提示：未定论前不预判，标注仅供参考，后续以当事人回应为准。
              </p>
              <button
                type="button"
                className="whitespace-nowrap cursor-pointer rounded-md bg-accent-500 px-3 py-1.5 text-xs font-medium text-background-50 transition-colors hover:bg-accent-600"
              >
                查看完整追踪 <i className="ri-arrow-right-line ml-0.5" aria-hidden="true" />
              </button>
            </div>
          </div>

          {/* 右侧：热门后续动态 */}
          <aside className="flex flex-col gap-4">
            <h4 className="flex items-center gap-2 text-sm font-bold text-foreground-900">
              <i className="ri-chat-history-line text-primary-500" aria-hidden="true" />
              正在追加后续的瓜
            </h4>
            {NEWS.filter((n) => n.label === '后续' || n.label === '反转').map((n) => (
              <button
                key={n.id}
                type="button"
                className="flex cursor-pointer items-start gap-3 rounded-xl border border-background-200/70 bg-background-100 p-4 text-left transition-colors hover:border-primary-200 hover:bg-background-50"
              >
                <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-accent-500 text-background-50">
                  <i className="ri-repeat-line text-sm" aria-hidden="true" />
                </span>
                <span>
                  <span className="line-clamp-2 text-xs font-medium leading-5 text-foreground-800">{n.title}</span>
                  <span className="mt-1.5 flex items-center gap-2 text-[11px] text-foreground-500">
                    <span className="rounded-full bg-secondary-200 px-1.5 py-px text-[10px] text-secondary-800">{n.label}</span>
                    {n.source} · {n.time}
                  </span>
                </span>
              </button>
            ))}
          </aside>
        </div>
      </div>
    </section>
  );
}